import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import CallToAction from "../components/CallToAction";


const NewsList = () => {
    const [news, setNews] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [page, setPage] = useState(1);
    const newsPerPage = 6;

    useEffect(() => {
        // Fetch categories
        client
            .fetch(`*[_type == "category"]{ _id, title }`)
            .then((data) => setCategories(data))
            .catch(console.error);

        // Fetch news based on category and pagination
        const categoryFilter = selectedCategory
            ? `&& category->title == "${selectedCategory}"`
            : '';
        client
            .fetch(
                `*[_type == "news" ${categoryFilter}] | order(publishedAt desc) [${
                    (page - 1) * newsPerPage
                }...${page * newsPerPage}] {
                    _id,
                    title,
                    slug,
                    mainImage,
                    excerpt,
                    publishedAt,
                    "categoryTitle": category->title
                }`
            )
            .then((data) => setNews(data))
            .catch(console.error);
    }, [selectedCategory, page]);

    const nextPage = () => setPage((prev) => prev + 1);
    const prevPage = () => setPage((prev) => Math.max(prev - 1, 1));

    const handleCategoryClick = (categoryTitle) => {
        setSelectedCategory(categoryTitle);
        setPage(1); // Reset lại trang khi thay đổi thể loại
    };


    return (
        <main className="bg-white py-20 sm:py-20  font-Inter">
            <div className="container mx-auto max-w-screen-xl px-4  pt-[72px] lg:pt-[109px]">
                {/* Hero Section */}
                <div className="relative bg-cover bg-center pt-12 pb-20">
                    <div
                        className="w-full flex-col justify-start  items-center gap-3 flex">
                        <h2
                            className="text-indigo-800 text-3xl sm:text-4xl font-semibold leading-normal text-center">
                            Tin tức và xu hướng</h2>
                        <p
                            className="font-OpenSans text-gray-700 text-base font-normal leading-relaxed text-center">
                            Cập nhật xu hướng & tin tức mới nhất về thiết kế, chất liệu và phong cách sống!</p>
                    </div>
                </div>

                {/* Danh sách bài viết */}
                <div className="my-8">
                    {/* Category Filter */}
                    <div className="my-6">
                        <label htmlFor="category-filter" className="block text-lg font-semibold mb-2">
                        </label>
                        <div className="relative">
                            <select
                                id="category-filter"
                                value={selectedCategory || ''}
                                onChange={(e) => handleCategoryClick(e.target.value || null)}
                                className="w-full max-w-[485px] px-4 py-2 bg-[#33367b] text-white font-bold"
                            >
                                <option value="">Tất cả thể loại</option>
                                {categories.map((category) => (
                                    <option key={category._id} value={category.title}>
                                        {category.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-4">
                        {news.map((item) => (
                            <a
                                key={item._id}
                                href={`/news/${item.slug.current}`}
                                className="block overflow-hidden group "
                            >
                                {/* Ảnh bài viết */}
                                <img
                                    src={urlFor(item.mainImage).url()}
                                    alt={item.title}
                                    className="w-full h-72 object-cover rounded-md"
                                />
                                <div className="py-4">
                                    {/* Tiêu đề bài viết */}
                                    <h3 className="text-xl text-gray-800 font-medium transition-colors duration-300">
                                        {item.title}
                                    </h3>
                                    <span className="font-medium text-[#BEAB81]"></span>{' '}
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault(); // Ngăn chặn chuyển hướng khi nhấn nút thể loại
                                            handleCategoryClick(item.categoryTitle);
                                        }}
                                        className="text-[#BEAB81] hover:underline"
                                    >
                                        {item.categoryTitle}
                                    </button>
                                    {' '}
                                    {/* Tóm tắt bài viết */}
                                    <p className="font-OpenSans text-base text-gray-600 mt-2">{item.excerpt}</p>
                                </div>
                            </a>
                        ))}
                    </div>

                </div>

                {/* Phân trang */}
                <div className="flex justify-between mt-6">
                    <button
                        onClick={prevPage}
                        disabled={page === 1}
                        className="px-2 py-2 bg-white border-2 border-[#33367b]  text-sm tracking-tight text-black font-bold "
                    >
                        Trang trước
                    </button>
                    <button
                        onClick={nextPage}
                        className="px-4 py-2 bg-[#33367b] text-white font-semibold  text-sm tracking-tight"
                    >
                        Trang sau
                    </button>
                </div>
            </div>
            <CallToAction/>
        </main>
    );
};

export default NewsList;
